import styled from 'styled-components';
import { WHITE } from '@swegon-core/uic/dist/src/theme';

export const Container = styled.div`
    width: calc(100vw - 78px);
    height: calc(100vh - 108px);
    margin: 8px 24px 12px;
    padding: 1rem;
    background-color: ${WHITE};
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const Content = styled.div`
    display: grid;
    grid-template-rows: 1fr 1fr 1fr 1fr;
`;

export const Title = styled.h1`
    margin: 0;
`;

export const Description = styled.div`
    > p {
        font-size: 1.25rem;
    }
`;

export const DetailedErrorDescription = styled.details`
    > p {
        font-size: 0.75rem;
    }
`;

export const ButtonContainer = styled.h5`
    display: flex;
    justify-content: space-between;
`;
